// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dcb72619","453":"4a028d95","732":"790b4e21"}[chunkId] + ".chunk.js";
};